import { Component } from '@angular/core';
import { releasedate, revision, version } from 'package.json';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `  
      <span class="version">ESS version {{version}} Build {{revision}} on {{releasedate}}</span>      
  `,
})
export class FooterComponent {
  public version: string = version;
  public revision: string = revision;
  public releasedate: string = releasedate;
}
